export const TrFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3_1047"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <circle
          cx="10"
          cy="10"
          r="10"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_3_1047)">
        <mask
          id="mask1_3_1047"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <circle
            cx="10"
            cy="10"
            r="10"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask1_3_1047)">
          <path
            d="M29.1666 0H-0.833435V20H29.1666V0Z"
            fill="#E30A17"
          />
          <path
            d="M17.2433 8.5892L15.585 9.12837L14.56 7.71753V9.4617L12.9017 10.0009L14.56 10.54V12.2842L15.585 10.8734L17.2433 11.4125L16.2183 10.0017L17.2433 8.5892Z"
            fill="white"
          />
          <path
            d="M10.3451 13.84C9.70467 13.8401 9.07438 13.6801 8.5116 13.3744C7.94883 13.0688 7.47144 12.6272 7.12288 12.09C6.77433 11.5527 6.56568 10.9368 6.51594 10.2983C6.4662 9.65978 6.57693 9.01899 6.83807 8.43422C7.09921 7.84946 7.50246 7.3393 8.01111 6.95017C8.51976 6.56104 9.11766 6.3053 9.75038 6.20624C10.3831 6.10718 11.0305 6.16794 11.6338 6.38299C12.237 6.59804 12.7769 6.96055 13.2043 7.43752C12.6488 6.55788 11.8225 5.88253 10.85 5.51316C9.87738 5.14379 8.81112 5.1004 7.81175 5.38954C6.81238 5.67867 5.934 6.28468 5.30889 7.11628C4.68377 7.94789 4.34576 8.96008 4.34576 10.0004C4.34576 11.0408 4.68377 12.053 5.30889 12.8846C5.934 13.7162 6.81238 14.3222 7.81175 14.6113C8.81112 14.9005 9.87738 14.8571 10.85 14.4877C11.8225 14.1184 12.6488 13.443 13.2043 12.5634C12.8444 12.9654 12.4037 13.2869 11.911 13.5069C11.4183 13.7269 10.8847 13.8404 10.3451 13.84Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};
